module.exports = __webpack_public_path__ + "static/gallery-27a754c04ace430d08a225d50d28d93e.jpg";